import HttpRequest from '../../util/HttpRequest'
import constant from '@/constant/constant'

export default {

  async LOAD_BOARD ({commit}, params) {
    const boardId = params.boardId
    return new Promise((resolve, reject) => {
      HttpRequest.get(`/api/v1/board/${boardId}`)
        .then(response => {
          commit('LOAD_BOARD', response)
          resolve(response)
        }).catch(err => reject(err))
    })
  },

  /**
   * 게시판 목록
   * @params {page, perPage}
   */
  async LOAD_BOARD_LIST ({commit}) {

    return new Promise((resolve, reject) => {
      HttpRequest.get('/api/v1/board')
        .then(response => {

          // mutations 메소드 호출
          commit('LOAD_BOARD_LIST', response)
          resolve(response)
        }).catch(err => reject(err))
    })
  },

  /**
   * 게시판 종류 불러오기
   * @params {page, perPage}
   */
  async LOAD_BOARD_TYPE_LIST ({commit}) {

    return new Promise((resolve, reject) => {
      HttpRequest.get('/api/v1/info/board/type')
        .then(response => {

          // mutations 메소드 호출
          commit('LOAD_BOARD_TYPE_LIST', response)
          resolve(response)
        }).catch(err => reject(err))
    })
  },

  // 공지사항 게시글 불러오기
  async LOAD_POST_LIST ({commit}, params) {

    const boardId = params.boardId
    const option = {
      params: {
        projectId: params.projectId,
        page: params.page,
        perPage: params.perPage,
        keyword: params.keyword,
        preview: params.preview,
        dateTarget: params.dateTarget,
        dateBegin: params.dateBegin,
        dateEnd: params.dateEnd,
        orderTarget: params.orderTarget,
        orderDirection: params.orderDirection
      }
    }

    return new Promise((resolve, reject) => {
      HttpRequest.get(`/api/v1/board/post/${boardId}`, option)
        .then(response => {
          commit('LOAD_POST_LIST', response)
          resolve(response)
        }).catch(err => reject(err))
    })
  },

  async LOAD_POST ({commit}, params) {
    const boardId = params.boardId
    const postId = params.postId
    return new Promise((resolve, reject) => {
      HttpRequest.get(`/api/v1/board/post/${boardId}/${postId}`)
        .then(response => {
          commit('LOAD_POST', response)
          resolve(response)
        }).catch(err => reject(err))
    })
  },

  async LOAD_COMMENT_LIST ({commit}, params) {
    const boardSlug = params.boardSlug
    const postId = params.postId
    return new Promise((resolve, reject) => {
      HttpRequest.get(`/api/v1/board/comment/${boardSlug}/${postId}`)
        .then(response => {
          commit('LOAD_COMMENT_LIST', response)
          resolve(response)
        }).catch(err => reject(err))
    })
  },

  async DELETE_POST ({commit}, params) {

    const boardId = params.boardId
    const postId = params.postId

    return new Promise((resolve, reject) => {
      HttpRequest.delete(`/api/v1/board/post/${boardId}/${postId}`)
        .then(response => {
          resolve(response)
        }).catch(err => reject(err))
    })
  },

  async CREATE_POST ({commit}, params) {
    const option = {
      title: params.title,
      content: params.content,
      parentId: params.parentId,
      uploads: params.uploads,
      projectId: params.projectId,
      projectOrderId: params.projectOrderId //orderId를 전송할 경우 반드시 projectId도 같이 보내야 한다.
    }

    const boardId = params.boardId
    return new Promise((resolve, reject) => {
      HttpRequest.put(`/api/v1/board/post/${boardId}/`, option)
        .then(response => {
          resolve(response)
        }).catch(err => reject(err))
    })
  },

  async UPDATE_POST ({commit}, params) {

    const option = {
      title: params.title,
      content: params.content,
      uploads: params.uploads,
      projectId: params.projectId,
      projectOrderId: params.projectOrderId  //orderId를 전송할 경우 반드시 projectId도 같이 보내야 한다.
    }

    const boardId = params.boardId
    const postId = params.postId

    return new Promise((resolve, reject) => {
      HttpRequest.post(`/api/v1/board/post/${boardId}/${postId}`, option)
        .then(response => {
          resolve(response)
        }).catch(err => reject(err))
    })
  },

  async ADD_COMMENT ({commit}, params) {

    const option = {
      parentId: params.parentId,
      content: params.comment
    }

    // 부모 댓글 ID가 없을 경우 변수 삭제
    if (!option.parentId || option.parentId === 0 || option.parentId === '0') {
      delete option.parentId
    }

    const boardSlug = params.boardSlug
    const postId = params.postId

    return new Promise((resolve, reject) => {
      HttpRequest.put(`/api/v1/board/comment/${boardSlug}/${postId}`, option)
        .then(response => {
          resolve(response)
        }).catch(err => reject(err))
    })
  },

  async UPDATE_COMMENT ({commit}, params) {

    const option = {
      content: params.comment
    }

    const boardSlug = params.boardSlug
    const postId = params.postId
    const commentId = params.commentId

    return new Promise((resolve, reject) => {
      HttpRequest.post(`/api/v1/board/comment/${boardSlug}/${postId}/${commentId}`, option)
        .then(response => {
          commit('UPDATE_COMMENT', response)
          resolve(response)
        }).catch(err => reject(err))
    })
  },

  async DELETE_COMMENT ({commit}, params) {

    const boardSlug = params.boardSlug
    const postId = params.postId
    const commentId = params.commentId

    return new Promise((resolve, reject) => {
      HttpRequest.delete(`/api/v1/board/comment/${boardSlug}/${postId}/${commentId}`)
        .then(response => {
          commit('DELETE_COMMENT', response)
          resolve(response)
        }).catch(err => reject(err))
    })
  },


  async LOAD_PHOTO_LIST ({commit}, params) {
    const boardId = params.boardId
    return new Promise((resolve, reject) => {
      HttpRequest.get(`/api/v1/photo`)
        .then(response => {
          commit('LOAD_PHOTO_LIST', response)
          resolve(response)
        }).catch(err => reject(err))
    })
  },

  async DELETE_PHOTO ({commit}, params) {

    const fileId = params.fileId

    return new Promise((resolve, reject) => {
      HttpRequest.delete(`/api/v1/photo/${fileId}`)
        .then(response => {
          commit('DELETE_PHOTO', response)
          resolve(response)
        }).catch(err => reject(err))
    })
  },

  async DELETE_PHOTO_LIST ({commit}, params) {

    const option = {
      fileIds: params.fileIds
    }

    return new Promise((resolve, reject) => {
      HttpRequest.post('/api/v1/photo/delete', option)
        .then(response => {
          commit('DELETE_PHOTO_LIST', response)
          resolve(response)
        }).catch(err => reject(err))
    })
  },


}
